"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

require("./TaskDragDrop.css");

var _Droppable = _interopRequireDefault(require("./Droppable"));

var _Draggable = _interopRequireDefault(require("./Draggable"));

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback"));

var _CompletedContext = require("../CompletedContext");

var _Alert = _interopRequireDefault(require("react-bootstrap/Alert"));

var _react2 = require("@wwnds/react");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function shuffle(a) {
  for (var i = a.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [a[j], a[i]];
    a[i] = _ref[0];
    a[j] = _ref[1];
  }

  return a;
}

var TaskDragDrop = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskDragDrop, _Component);

  var _super = (0, _createSuper2.default)(TaskDragDrop);

  function TaskDragDrop(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskDragDrop);
    _this = _super.call(this, props);
    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.feedback = undefined;
      _this.state.correct = false;
      _this.state.hotspotChildren = props.hotspots.map(function () {
        return [];
      });
      _this.state.hotspotChildren[props.hotspots.length] = props.choices.map(function (v, k) {
        v.index = k;
        return v;
      });
      _this.state.mouseX = 0;
      _this.state.mouseY = 0;
      _this.state.minX = 0;
      _this.state.maxX = 0;
      _this.state.minY = 0;
      _this.state.maxY = 0;
      _this.state.figureScale = 1;
      _this.state.hovered = -1;

      if (props.randomize) {
        shuffle(_this.state.hotspotChildren[props.hotspots.length]);
      }
    }

    _this.generateDraggables = _this.generateDraggables.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateBounds = _this.updateBounds.bind((0, _assertThisInitialized2.default)(_this));
    _this.canDrop = _this.canDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateHotspotsAfterDrop = _this.updateHotspotsAfterDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.ref = /*#__PURE__*/_react.default.createRef();
    _this.figureRef = /*#__PURE__*/_react.default.createRef();
    _this.innerFigureRef = /*#__PURE__*/_react.default.createRef();
    console.log("task constructed", _this.state);
    _this.choices = _this.props.choices.map(function (choice) {
      return {
        content: choice.content,
        sourceArray: undefined
      };
    });
    return _this;
  }

  (0, _createClass2.default)(TaskDragDrop, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (this.state.hotspotChildren !== prevstate.hotspotChildren) {
        var completed = true;

        for (var i = 0; i < this.state.hotspotChildren.length - 1; i++) {
          if (this.state.hotspotChildren[i].length === 0) {
            completed = false;
          }
        }

        if (this.props.submit) {
          this.setState({
            canSubmit: completed
          });
        } else {
          console.log("TaskDragDrop completed (no submit)");
          this.setState({
            completed: completed
          });
        }
      }

      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i]; // Keep our stored state synchronized

        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      console.log("task mount", this.state); // Notify the parent of our completion status

      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
      window.addEventListener("resize", this.updateBounds);
      this.updateBounds();
      window.setTimeout(function () {
        _this2.updateBounds();

        window.setTimeout(function () {
          _this2.updateBounds();
        }, 0);
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateBounds);
    }
  }, {
    key: "updateBounds",
    value: function updateBounds() {
      var rect = this.ref.current.getBoundingClientRect();
      var figrect = this.figureRef.current.getBoundingClientRect();
      var infigrect = this.innerFigureRef.current.getBoundingClientRect();
      var outerWidth = figrect.width;
      var innerWidth = infigrect.width;
      var scale = Math.min(1, outerWidth / (innerWidth / this.state.figureScale)); //console.log("scale", this.state.figureScale, "outer width:", figrect.width, "inner width:", infigrect.width, "outer scroll width:", this.figureRef.current.scrollWidth, "inner scroll width:", this.innerFigureRef.current.scrollWidth)
      //console.log("inner height:", infigrect.height, "outer height:", figrect.height)

      if (!this.props.responsive) {
        scale = 1;
      }

      this.setState({
        minX: rect.left,
        maxX: rect.right,
        minY: rect.top,
        maxY: rect.bottom,
        figureScale: scale,
        figureHeight: infigrect.height
      });
    }
  }, {
    key: "generateDraggables",
    value: function generateDraggables(children, droppableId, hidden) {
      var _this3 = this;

      var childrenarray = [];
      this.hotspotMap = [];
      children.forEach(function (v, k) {
        if (!v) return;

        _this3.hotspotMap.push(droppableId + ";" + k + ";" + v.index);

        children[k].sourceArray = _this3.hotspotMap[k];

        _this3.choices.forEach(function (item, i) {
          if (v.content === item.content) {
            _this3.choices[i] = v;
            _this3.choices[i].sourceArray = droppableId + ";" + k + ";" + v.index;
            _this3.choices[i].choiceIndex = i;
          }
        });

        childrenarray.push( /*#__PURE__*/_react.default.createElement(_Draggable.default, {
          id: _this3.hotspotMap[k],
          labelWidth: "min(" + _this3.props.labelWidth + ", 100%)",
          ariaHidden: hidden,
          key: k,
          mouseX: _this3.state.mouseX,
          mouseY: _this3.state.mouseY,
          mouseDown: _this3.state.mouseDown,
          minX: _this3.state.minX,
          maxX: _this3.state.maxX,
          minY: _this3.state.minY,
          maxY: _this3.state.maxY,
          onDragStart: function onDragStart() {
            _this3.setState({
              dragging: true
            });
          },
          onDragEnd: function onDragEnd() {
            _this3.setState({
              dragging: false
            });
          }
        }, v.content));
      });
      return childrenarray;
    }
  }, {
    key: "canDrop",
    value: function canDrop(source, destination, choice) {
      console.log("choice", choice, "is moving from", source, "to", destination);

      if (this.state.completed || this.state.hotspotChildren[destination].length && !this.props.submit) {
        return false;
      }

      if (destination === this.props.hotspots.length) {
        this.setState({
          feedback: undefined
        });
      } else if (!this.props.submit) {
        var correct = this.props.hotspots[destination].correct.includes(choice);
        this.setState({
          correct: correct,
          feedback: this.props.feedback[destination][choice],
          showModal: !correct ? true : null
        });
        return correct;
      }

      return true;
    }
  }, {
    key: "updateHotspotsAfterDrop",
    value: function updateHotspotsAfterDrop(ids, accessibleLocation) {
      // let ids = this.state.dragElement.id.split(";")
      var source = Number(ids[0]); // The source array

      var destination = this.state.hovered === -1 ? accessibleLocation : this.state.hovered; // The destination array

      var child = Number(ids[1]); // The index in the source array the child came from

      var choice = Number(ids[2]); // The index in props.choices the child came from

      console.log(ids, source, destination, child, choice);

      if (source !== destination) {
        if (this.canDrop(source, destination, choice)) {
          var hotspotChildren = this.state.hotspotChildren.slice();
          var removed = hotspotChildren[source].splice(child, 1);

          if (this.props.hotspots.length === this.props.choices.length) {
            var displaced = hotspotChildren[destination].splice(0, 1);
            hotspotChildren[source].push(displaced[0]);
          }

          hotspotChildren[destination].push(removed[0]);
          this.setState({
            hotspotChildren: hotspotChildren
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ref,
        key: this.props.key,
        className: "task task-drag-drop" + (this.props.responsive ? " responsive" : ""),
        onMouseMove: function onMouseMove(e) {
          var x = e.nativeEvent.pageX;
          var y = e.nativeEvent.pageY;

          _this4.setState({
            mouseX: x,
            mouseY: y
          });

          _this4.updateBounds();
        },
        onMouseDown: function onMouseDown(e) {
          var node = e.target;

          while (node && !(node.id && node.id.includes(";"))) {
            node = node.parentNode;
          }

          if (node && node.id && node.id.includes(";")) _this4.setState({
            mouseDown: true,
            dragElement: node
          });
        },
        onMouseUp: function onMouseUp() {
          if (_this4.state.mouseDown && _this4.state.dragElement && _this4.state.hovered !== -1) {
            _this4.updateHotspotsAfterDrop(_this4.state.dragElement.id.split(";"));
          }

          _this4.setState({
            mouseDown: false,
            dragElement: undefined,
            hovered: -1,
            dragging: false
          });
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "figure figure-outer",
        style: {
          width: this.props.vertical ? "50%" : "100%",
          height: this.state.figureHeight ? this.state.figureHeight + "px" : undefined
        },
        ref: this.figureRef
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "figure figure-inner",
        style: {
          transform: this.props.responsive ? "scale(" + this.state.figureScale + ")" : undefined,
          position: this.props.responsive ? "relative" : undefined
        },
        ref: this.innerFigureRef
      }, this.props.picture ? /*#__PURE__*/_react.default.createElement("img", {
        src: this.props.picture,
        alt: "",
        style: {
          width: "100%"
        }
      }) : this.props.children.map ? this.props.children.map(function (child) {
        if (child && child.type && (child.type === TaskDragDrop.Hotspots || child.type.name === "Hotspots")) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            parent: _this4
          });
        }

        return child;
      }) : this.props.children, this.props.picture && /*#__PURE__*/_react.default.createElement(TaskDragDrop.Hotspots, {
        parent: this
      }))), /*#__PURE__*/_react.default.createElement(_Droppable.default, {
        style: this.props.vertical ? {
          width: "50%",
          float: "left"
        } : {},
        choices: this.choices,
        className: "wordbank",
        labelWidth: this.props.labelWidth,
        dragElement: this.state.dragElement,
        mouseX: this.state.mouseX,
        mouseY: this.state.mouseY,
        hovered: this.state.hovered === this.props.hotspots.length,
        completed: this.state.completed,
        onHover: function onHover() {
          _this4.setState({
            hovered: _this4.props.hotspots.length
          });
        },
        onEndHover: function onEndHover() {
          _this4.setState({
            hovered: _this4.state.hovered === _this4.props.hotspots.length ? -1 : _this4.state.hovered
          });
        }
      }, this.generateDraggables(this.state.hotspotChildren[this.props.hotspots.length], this.props.hotspots.length, true)), this.props.submit && !this.state.completed && /*#__PURE__*/_react.default.createElement(_react2.Button, {
        className: "bdg-submit-button",
        type: "submit",
        disabled: !this.state.canSubmit,
        onClick: function onClick() {
          var completed = true;
          console.log("TaskDragDrop submit");

          for (var i = 0; i < _this4.state.hotspotChildren.length - 1; i++) {
            if (_this4.state.hotspotChildren[i].length === 0) {
              completed = false;
              console.log("TaskDragDrop submit completed = false");
            } else {
              var _iterator = (0, _createForOfIteratorHelper2.default)(_this4.state.hotspotChildren[i]),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var child = _step.value;
                  var choice = child.choiceIndex;

                  var c = _this4.props.hotspots[i].correct.includes(choice);

                  console.log("TaskDragDrop choice", choice, "c", c);

                  _this4.setState({
                    correct: c,
                    feedback: _this4.props.feedback[i][choice],
                    showModal: !c ? true : null
                  });

                  if (!c) {
                    completed = false;

                    var hotspotChildren = _this4.props.hotspots.map(function () {
                      return [];
                    });

                    hotspotChildren[_this4.props.hotspots.length] = _this4.props.choices.map(function (v, k) {
                      v.index = k;
                      return v;
                    });

                    _this4.setState({
                      hotspotChildren: hotspotChildren
                    });

                    console.log("TaskDragDrop reset");
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          }

          if (completed) {
            _this4.setState({
              completed: true
            });

            console.log("TaskDragDrop completed on submit");
          }
        }
      }, "Submit"), this.state.feedback && this.state.correct && /*#__PURE__*/_react.default.createElement(_Alert.default, {
        variant: "success"
      }, this.state.feedback), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showModal && !this.state.completed,
        onHide: function onHide() {
          _this4.setState({
            showModal: false
          });
        }
      }, this.state.feedback));
    }
  }], [{
    key: "Hotspots",
    value: function Hotspots(props) {
      var parent = props.parent;
      var parentProps = props.parent.props;
      var parentState = props.parent.state; //let parentSetState = props.parent.setState

      return parentProps.hotspots.map(function (v, k) {
        return /*#__PURE__*/_react.default.createElement(_Droppable.default, {
          key: k,
          active: parentState.dragging,
          submit: parentProps.submit,
          hotspotLabel: parentProps.hotspots[k].hotspotLabel,
          className: "hotspot" + (parentState.hotspotChildren[k].length && !parentProps.submit ? " disabled" : ""),
          updateHotspotsAfterDrop: parent.updateHotspotsAfterDrop,
          accessibleLocation: k,
          choices: parent.choices,
          unplacedChoices: parentProps.submit ? undefined : parentState.hotspotChildren[parentProps.hotspots.length].map(function (obj) {
            return obj ? obj.choiceIndex : undefined;
          }),
          style: (0, _objectSpread2.default)({
            position: "absolute"
          }, v.style),
          hotspot: v,
          dragElement: parentState.dragElement,
          mouseX: parentState.mouseX,
          mouseY: parentState.mouseY,
          hovered: parentState.hovered === k,
          onHover: function onHover() {
            parent.setState({
              hovered: k
            });
          },
          onEndHover: function onEndHover() {
            parent.setState({
              hovered: parentState.hovered === k ? -1 : parentState.hovered
            });
          }
        }, parent.generateDraggables(parentState.hotspotChildren[k], k));
      });
    }
  }]);
  return TaskDragDrop;
}(_react.Component);

exports.default = TaskDragDrop;
TaskDragDrop.contextType = _CompletedContext.CompletedContext;